module.exports = __webpack_public_path__ + "static/media/App icon SNKRS.6c55e65a.png";